import type { PaletteType } from "@material-ui/core";

import defaultTheme from "./coretex-theme";

const theme = {
  ...defaultTheme,
  themeName: "Coretex Rodeo Standard Dark Mode",
  palette: {
    type: "dark" as PaletteType,
    ...defaultTheme.palette,
  },
};

export default theme;
